// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--aiVia","dropdown":"dropdown--mWXe1","text":"text--fb7eQ","all":"all--67YVD","success":"success--3URqn","loading":"loading--G2PMd","failed":"failed--5cfz8"};